import React from 'react';
import PropTypes from 'prop-types';
import Retelling from './Retelling';
import Retell from './Retell';
import { BOOK_TYPE, LABEL } from '../../../../../../constants/shared/TrcConstants';

const { FICTION } = BOOK_TYPE;
const { RECALL, RETELL, RETELL_OR_RECALL, RETELLING } = LABEL;

const getRetellTitleAndContent = ({
    retellRecall,
    retelling,
    retellOrRecall,
    bookType,
    values,
}) => {
    const { retellValues, recallValues, fictionValues, nonFictionValues } = values;
    if (retellOrRecall) {
        if (bookType === FICTION) {
            return { name: RETELL, content: retellValues };
        }
        return { name: RECALL, content: recallValues };
    }
    if (retellRecall) {
        return {
            name: RETELL_OR_RECALL,
            content: bookType === FICTION ? fictionValues : nonFictionValues,
        };
    }
    if (retelling) {
        return { name: RETELLING };
    }
    return {};
};

const RetellTable = ({ retellScore, retellings, ...props }) => {
    if (retellScore) {
        const currentRetellInfo = getRetellTitleAndContent(props);
        if (currentRetellInfo.name === RETELLING) {
            return (
                <Retelling
                    retellings={retellings}
                    bookType={props.bookType}
                    retellScore={retellScore}
                />
            );
        }
        return <Retell currentRetellInfo={currentRetellInfo} retellScore={retellScore} />;
    }
    return null;
};

RetellTable.defaultProps = {
    retellRecall: false,
    retelling: false,
    retellOrRecall: false,
    retellScore: {},
    retellings: [],
    bookType: null,
    values: {},
};

RetellTable.propTypes = {
    retellRecall: PropTypes.bool,
    retelling: PropTypes.bool,
    retellOrRecall: PropTypes.bool,
    retellings: PropTypes.array,
    retellScore: PropTypes.object,
    bookType: PropTypes.string,
    values: PropTypes.object,
};

export default RetellTable;
